import { render, staticRenderFns } from "./packageModuleItem.vue?vue&type=template&id=efe7aea2&scoped=true&"
import script from "./packageModuleItem.vue?vue&type=script&lang=js&"
export * from "./packageModuleItem.vue?vue&type=script&lang=js&"
import style0 from "./packageModuleItem.vue?vue&type=style&index=0&id=efe7aea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe7aea2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efe7aea2')) {
      api.createRecord('efe7aea2', component.options)
    } else {
      api.reload('efe7aea2', component.options)
    }
    module.hot.accept("./packageModuleItem.vue?vue&type=template&id=efe7aea2&scoped=true&", function () {
      api.rerender('efe7aea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/components/packageModuleItem.vue"
export default component.exports